// extracted by mini-css-extract-plugin
export default {"loadingSpinner":"Spinner_loadingSpinner__lqwZ4","spinner":"Spinner_spinner__AiXqN","spinnerContainer":"Spinner_spinnerContainer__N246s"};